<template>
  <div id="assets">
    <!-- navbar on top of page -->

    <nav class="navbar navbar-expand-lg navbar-dark topbar">
      <a class="navbar-brand" href="home">
        <img
          src="../assets/img/iLogDPI.png"
          style="float:left;width:80px;height:40px;"
        />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link active" href="home"
              >Dashboard
              <span class="sr-only">(current)</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="users">Users</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="assets">
              Assets
            </a>
          </li>
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <input
            class="form-control mr-sm-2"
            type="search"
            placeholder="Search..."
            aria-label="Search"
            v-model="search"
          />
        </form>
      </div>
      <div v-if="role == 'management'">
        <button
          class="btn btn-outline-success"
          style="margin:5px;"
          data-toggle="modal"
          data-target="#addNewAssetBox"
          @click="
            ;(checkform = false), (hostname = null), (customerName = null)
          "
        >
          Add Asset
        </button>
      </div>
      <button class="btn btn-outline-danger" @click="logout">Logout</button>
    </nav>
    <br /><br />

    <!-- <cpuChart> </cpuChart> -->
    <div v-if="role == 'management'" class="text_hd">DPI ADMIN MONITOR</div>
    <div v-else class="text_hd">Welcome: {{ this.username }}</div>
    <div class="container" v-if="role == 'management' || 'user'">
      <div v-if="loading">
        <br />
        <lottie-player
          src="https://assets2.lottiefiles.com/datafiles/riuf5c21sUZ05w6/data.json"
          background="transparent"
          speed="1"
          style="width: 100%; height: 300px; "
          loop
          autoplay
        ></lottie-player>
        <!-- {{ this.assets }} -->
      </div>

      <div v-else class="fontcpu">
        <!-- <br /><br /><br /><br /> -->
        <!-- {{ this.customer_name }} -->
        <div class="float-right">
          <!-- <b-badge  pill variant="success">ONLINE </b-badge> : {{ hostnameassetsON }}   -->
          <b-badge pill variant="success">
            ONLINE <span class="badge badge-light">{{ hostnameassetsON }}</span>
          </b-badge>
          |
          <!-- <b-badge pill variant="danger">OFFLINE </b-badge> : {{ hostnameassetsOFF }}  -->
          <b-badge pill variant="danger">
            OFFLINE
            <span class="badge badge-light">{{ hostnameassetsOFF }}</span>
          </b-badge>
        </div>
        <br /><br />
        <b-container class="bv-example-row mb-3">
          <b-row cols="2">
            <b-col v-for="x in hostnameassetsON" :key="x">
              <div class="fontcpu" v-if="load5[x - 1] != 1">
                <b-card
                  border-variant="success"
                  header-bg-variant="success"
                  header-text-variant="white"
                  bg-variant="dark"
                  align="center"
                >
                  <b-card-header>
                    {{ hostdpi[x - 1] }}
                    <b-badge pill variant="success">
                      <svg
                        class="bi bi-bar-chart-fill"
                        width="1em"
                        height="1em"
                        viewBox="0 3 16 16"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="4" height="5" x="1" y="10" rx="1" />
                        <rect width="4" height="9" x="6" y="6" rx="1" />
                        <rect width="4" height="14" x="11" y="1" rx="1" />
                      </svg>
                      ONLINE
                    </b-badge>
                  </b-card-header>
                  <br />
                  <b-card-text class="text-center">
                    <div
                      :id="carouselCPU[x - 1]"
                      class="carousel slide"
                      data-ride="carousel"
                    >
                      <ol class="carousel-indicators" style="margin: -15px;">
                        <li
                          :data-target="'#' + carouselCPU[x - 1]"
                          data-slide-to="0"
                          class="active"
                        ></li>
                        <li
                          :data-target="'#' + carouselCPU[x - 1]"
                          data-slide-to="1"
                        ></li>
                      </ol>
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <div
                            class="card bg-info mb-3"
                            img
                            src=".../?auto=yes&bg=777&fg=555&text=First slide"
                            alt="First slide"
                          >
                            <div class="card-header">
                              CPU Load
                            </div>

                            <ul class="list-group list-group-flush">
                              <li class="list-group-item text-dark">
                                <cpuGauge
                                  :value="parseFloat(load5[x - 1])"
                                ></cpuGauge>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="carousel-item">
                          <div
                            class="card bg-info mb-3"
                            img
                            src=".../?auto=yes&bg=777&fg=555&text=Second slide"
                            alt="Second slide"
                          >
                            <div class="card-header">
                              CPU Load
                            </div>

                            <ul class="list-group list-group-flush">
                              <li class="list-group-item text-dark">
                                <cpuChart :data="cpuloadchart"> </cpuChart>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <!-- <a
                          class="carousel-control-prev"
                          :href="'#' + carouselCPU[x - 1]"
                          role="button"
                          data-slide="prev"
                        >
                          <span
                            class="carousel-control-prev-icon"
                            aria-hidden="true"
                          ></span>
                          <span class="sr-only">Previous</span>
                        </a>
                        <a
                          class="carousel-control-next"
                          :href="'#' + carouselCPU[x - 1]"
                          role="button"
                          data-slide="next"
                        >
                          <span
                            class="carousel-control-next-icon"
                            aria-hidden="true"
                          ></span>
                          <span class="sr-only">Next</span>
                        </a> -->
                      </div>
                    </div>
                    <br />

                    <div
                      :id="carouselResources[x - 1]"
                      class="carousel slide"
                      data-ride="carousel"
                    >
                      <ol class="carousel-indicators" style="margin: -15px;">
                        <li
                          :data-target="'#' + carouselResources[x - 1]"
                          data-slide-to="0"
                          class="active"
                        ></li>
                        <li
                          :data-target="'#' + carouselResources[x - 1]"
                          data-slide-to="1"
                        ></li>
                      </ol>
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <div class="card bg-info mb-3">
                            <div class="card-header">
                              Resources
                            </div>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">
                                <span
                                  class="badge badge-pill badge-dark float-left"
                                  >Disk</span
                                >
                                <br />
                                <resourcesGauge
                                  active
                                  :percent="parseFloat(diskUsedPercent[x - 1])"
                                  :line-height="15"
                                  :total="diskTotal[x - 1]"
                                />
                                <span
                                  class="float-left badge badge-secondary text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  {{ diskUsed[x - 1] }} Used</span
                                >
                                <span
                                  v-if="parseFloat(diskUsedPercent[x - 1]) < 65"
                                  class="float-right badge badge-success text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ diskFree[x - 1] }}</span
                                >
                                <span
                                  v-else-if="
                                    parseFloat(diskUsedPercent[x - 1]) < 80
                                  "
                                  class="float-right badge badge-warning text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ diskFree[x - 1] }}</span
                                >
                                <span
                                  v-else-if="
                                    parseFloat(diskUsedPercent[x - 1]) < 90
                                  "
                                  class="float-right badge badge-warning text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ diskFree[x - 1] }}</span
                                >
                                <span
                                  v-else
                                  class="float-right badge badge-danger text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ diskFree[x - 1] }}</span
                                >
                              </li>
                              <li class="list-group-item">
                                <div
                                  class="badge badge-pill badge-dark float-left"
                                >
                                  Memory
                                </div>
                                <br />
                                <resourcesGauge
                                  active
                                  :total="memTotal[x - 1]"
                                  :percent="parseFloat(memUsedPercent[x - 1])"
                                  :line-height="15"
                                />

                                <span
                                  class="float-left badge badge-secondary text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  {{ memUsed[x - 1] }} Used</span
                                >
                                <span
                                  v-if="parseFloat(memUsedPercent[x - 1]) < 65"
                                  class="float-right badge badge-success text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ memFree[x - 1] }}</span
                                >
                                <span
                                  v-else-if="
                                    parseFloat(memUsedPercent[x - 1]) < 80
                                  "
                                  class="float-right badge badge-warning text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ memFree[x - 1] }}</span
                                >
                                <span
                                  v-else-if="
                                    parseFloat(memUsedPercent[x - 1]) < 90
                                  "
                                  class="float-right badge badge-warning text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ memFree[x - 1] }}</span
                                >
                                <span
                                  v-else
                                  class="float-right badge badge-danger text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ memFree[x - 1] }}</span
                                >
                              </li>
                              <li class="list-group-item">
                                <span
                                  class="badge badge-pill badge-dark float-left"
                                  >Swap</span
                                >
                                <br />
                                <resourcesGauge
                                  active
                                  :percent="parseFloat(swapUsedPercent[x - 1])"
                                  :line-height="15"
                                  :total="swapTotal[x - 1]"
                                />

                                <span
                                  class="float-left badge badge-secondary text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  {{ swapUsed[x - 1] }} Used</span
                                >
                                <span
                                  v-if="parseFloat(swapUsedPercent[x - 1]) < 65"
                                  class="float-right badge badge-success text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ swapFree[x - 1] }}</span
                                >
                                <span
                                  v-else-if="
                                    parseFloat(swapUsedPercent[x - 1]) < 80
                                  "
                                  class="float-right badge badge-warning text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ swapFree[x - 1] }}</span
                                >
                                <span
                                  v-else-if="
                                    parseFloat(swapUsedPercent[x - 1]) < 90
                                  "
                                  class="float-right badge badge-warning text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ swapFree[x - 1] }}</span
                                >
                                <span
                                  v-else
                                  class="float-right badge badge-danger text-wrap"
                                  style="max-width: 7rem;"
                                >
                                  Free {{ swapFree[x - 1] }}</span
                                >
                                <br />
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="carousel-item">
                          <div class="card bg-info mb-3" alt="Second slide">
                            <div class="card-header">
                              Resources
                            </div>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item">
                                <!-- <span
                                  class="badge badge-pill badge-dark float-left"
                                  >Resources</span
                                > -->
                                <br />
                                <resourcesChart
                                  :data="resourceschartall"
                                  title="Disk Usage"
                                />
                              </li>
                              <!-- 
                              <li class="list-group-item">
                                <div
                                  class="badge badge-pill badge-dark float-left"
                                >
                                  Memory
                                </div>
                                <br />
                                <resourcesChart :data="memchart" title="Memory Usage" />

                              </li>
                              <li class="list-group-item">
                                <span
                                  class="badge badge-pill badge-dark float-left"
                                  >Swap</span
                                >
                                <br /> -->
                              <!-- <resourcesChart :data="swapchart" title="Swap Usage" />

                              </li> -->
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-card>
              </div>
              <br />
            </b-col>
          </b-row>
        </b-container>
        <!-- {{ resourceschartall }} -->
        <!-- disk = {{diskchart}} <br>
        mem = {{memchart}}<br>
        swap = {{swapchart}} -->
        <b-container class="bv-example-row mb-3">
          <b-row cols="3">
            <b-col v-for="x in hostnameassetsOFF" :key="x">
              <div class="fontcpu">
                <b-card
                  border-variant="danger"
                  header-bg-variant="danger"
                  header-text-variant="white"
                  bg-variant="dark"
                  align="center"
                >
                  <b-card-header v-if="hostdpi.length == 0">
                    {{ hostnameassets[x - 1] }}
                    <b-badge pill variant="danger">
                      <svg
                        class="bi bi-cloud-slash"
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.901 6.023A3.5 3.5 0 1 0 3.5 13h7.379l-1-1H3.5a2.5 2.5 0 1 1 .423-4.965l.964.164.031-.16-1.017-1.016zm10.125 5.882a1.5 1.5 0 0 0-.289-2.886L12.7 8.854l.216-1.028a4 4 0 0 0-6.682-3.714l-.707-.708a5 5 0 0 1 8.368 4.626 2.501 2.501 0 0 1 .88 4.621l-.748-.746z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M13.646 14.354l-12-12 .708-.708 12 12-.707.707z"
                        />
                      </svg>
                      OFFLINE</b-badge
                    >
                  </b-card-header>
                  <b-card-header v-else>
                    {{ hostdpiOffData[x - 1] }}
                    <b-badge pill variant="danger">
                      <svg
                        class="bi bi-cloud-slash"
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.901 6.023A3.5 3.5 0 1 0 3.5 13h7.379l-1-1H3.5a2.5 2.5 0 1 1 .423-4.965l.964.164.031-.16-1.017-1.016zm10.125 5.882a1.5 1.5 0 0 0-.289-2.886L12.7 8.854l.216-1.028a4 4 0 0 0-6.682-3.714l-.707-.708a5 5 0 0 1 8.368 4.626 2.501 2.501 0 0 1 .88 4.621l-.748-.746z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M13.646 14.354l-12-12 .708-.708 12 12-.707.707z"
                        />
                      </svg>
                      OFFLINE</b-badge
                    >
                  </b-card-header>
                </b-card>
              </div>
              <br />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import jwtDecode from 'jwt-decode'
import Vuelidate from 'vuelidate'
import axios from 'axios'

import firebase from 'firebase/app'
import '@firebase/auth'
import '@firebase/database'
import '@firebase/analytics'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import { required } from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

import cpuGauge from '@/components/cpuGauge'
import cpuChart from '@/components/cpuChart'
import resourcesGauge from '@/components/resourcesGauge'
import resourcesChart from '@/components/resourcesChart'
// import echartGauge from '@/components/diskGauge'

const assetsRef = firebase.database().ref('Assets')
const assetsOR = firebase
  .database()
  .ref('Assets')
  .orderByChild('hostname')

export default {
  name: 'cpu',
  components: {
    cpuGauge,
    cpuChart,
    resourcesGauge,
    resourcesChart,
    // echartGauge,
  },
  data() {
    return {
      customerName: '',
      carouselCPU: [],
      carouselResources: [],

      cpuloadchart: [],
      diskchart: [],
      memchart: [],
      swapchart: [],
      resourceschartall: [],

      hostname: '',
      assets: [],
      hostnameassets: [],
      hostnameassetsON: 0,
      hostnameassetsOFF: [],
      search: '',
      editName: null,
      checkform: false,
      checkEditform: true,
      submitted: false,
      updateAsset: false,
      notUnique: true,
      assetfailed: false,
      testdpii: [],
      dpisystem: [],

      //System Stat Event

      //hostname

      hostdpi: [],
      hostdpiOFF: [],
      hostdpiOffData: [],

      runOnlyOnce: false,

      loading: true,

      //raw log
      healthlog: [],

      //cpu load
      load5: [],

      //disk
      diskFree: [],
      diskFreePercent: [],
      diskTotal: [],
      diskUsed: [],
      diskUsedPercent: [],

      //memory
      memFree: [],
      memFreePercent: [],
      memTotal: [],
      memUsed: [],
      memUsedPercent: [],

      //swap
      swapFree: [],
      swapFreePercent: [],
      swapTotal: [],
      swapUsed: [],
      swapUsedPercent: [],
    }
  },
  validations: {
    customerName: { required },
    hostname: { required },
  },

  created() {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.role = this.decoded.role
    this.username = this.decoded.username

    //Users DB
    assetsOR.on('child_added', (snapshot) => {
      this.assets.push({ ...snapshot.val(), id: snapshot.key })
    })
    assetsOR.on('child_removed', (snapshot) => {
      const deleteUser = this.assets.find((assets) => assets.id == snapshot.key)
      const index = this.assets.indexOf(deleteUser)
      this.assets.splice(index, 1)
    })
    assetsOR.on('child_changed', (snapshot) => {
      const updateUser = this.assets.find((assets) => assets.id == snapshot.key)
      updateUser.hostname = snapshot.val().hostname
      updateUser.customerName = snapshot.val().customerName
    })
    //Assets DB
  },
  computed: {
    filteredUser() {
      return this.assets.filter((assets) => {
        return assets.hostname.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  beforeCreate() {},
  async mounted() {
    await this.callAssets()
    await setTimeout(this.setLoading, 3000)
    // await this.getResourcesDPI()
  },
  methods: {
    setLoading() {
      this.loading = false
    },
    async callAssets() {
      if (this.role == 'user') {
        this.customer_name = this.decoded.customer_name
        await assetsOR.on(
          'value',
          (snapshot) => {
            snapshot.forEach((childSnapshot) => {
              if (this.customer_name == childSnapshot.val().customerName) {
                this.hostnameassets.push(childSnapshot.val().hostname)
              }
            })
            this.getResourcesDPIadmin()
          },
          function(errorObject) {
            console.log('The read failed: ' + errorObject.code)
          }
        )
      } else if (this.role == 'management') {
        await assetsOR.on(
          'value',
          (snapshot) => {
            snapshot.forEach((childSnapshot) => {
              this.hostnameassets.push(childSnapshot.val().hostname)
            })
            this.getResourcesDPIadmin()
            //this.getResourcesDPIadmintest()
          },
          function(errorObject) {
            console.log('The read failed: ' + errorObject.code)
          }
        )
      }
    },
    async getResourcesDPI() {
      //console.log(this.hostnameassets.length)
      for (let x = 0; x < this.hostnameassets.length; x++) {
        let status = this
        axios({
          method: 'POST',
          url: 'https://portal.ilog.ai:8001/api/query/search',
          headers: { Authorization: this.token },
          data: {
            start: 'now-15m',
            end: 'now',
            instance: 'http://3.1.180.118:7000',
            index: this.hostnameassets[x].replace('.ilog.ai', ''),
            stores: [],
          },
        }).then(function(response) {
          if (response.data.length > 0) {
            // for (let x = 0; x < status.hostdpi.length; x++) {
            //   for (let y = 0; y < status.hostnameassets.length; y++) {
            //     if (status.hostnameassets[y] != status.hostdpi[x]) {
            //       if (y != 0) {
            //         if (status.hostnameassets[y] != status.hostdpiOffData[y]) {
            //           status.hostdpiOffData.push(status.hostnameassets[y])
            //         }
            //       }
            //     } else {
            //       status.hostdpiOffData.push(status.hostnameassets[y])
            //     }
            //   }
            //   console.log(status.hostdpiOffData)
            // }
            let count = response.data.length
            let rawlog = response.data[count - 1]

            //hostname
            //console.log(rawlog._source.hostname)
            for (let x = 0; x < status.assets.length; x++) {
              //console.log(rawlog._source.hostname)
              // console.log(status.assets[x].hostname +'1')
              // console.log(rawlog._source.hostname+ )
              if (
                rawlog._source.hostname + '.ilog.ai' ==
                status.assets[x].hostname
              ) {
                status.hostdpi.push(status.assets[x].hostname)

                // rawlog
                status.healthlog.push(rawlog)

                // cpu load
                status.load5.push(parseFloat(rawlog._source.load5).toFixed(2))

                status.status.diskFree // disk
                  .push(status.bytesToSize(rawlog._source.diskFree))
                status.diskFreePercent.push(
                  status.numberToPercentage(rawlog._source.diskFreePercent)
                )
                status.diskTotal.push(
                  status.bytesToSize(rawlog._source.diskTotal)
                )
                status.diskUsed.push(
                  status.bytesToSize(rawlog._source.diskUsed)
                )
                status.diskUsedPercent.push(
                  status.numberToPercentage(rawlog._source.diskUsedPercent)
                )

                // memory
                status.memFree.push(status.bytesToSize(rawlog._source.memFree))
                status.memFreePercent.push(
                  status.numberToPercentage(rawlog._source.memFreePercent)
                )
                status.memTotal.push(
                  status.bytesToSize(rawlog._source.memTotal)
                )
                status.memUsed.push(status.bytesToSize(rawlog._source.memUsed))
                status.memUsedPercent.push(
                  status.numberToPercentage(rawlog._source.memUsedPercent)
                )

                // swap
                status.swapFree.push(
                  status.bytesToSize(rawlog._source.swapFree)
                )
                status.swapFreePercent.push(
                  status.numberToPercentage(rawlog._source.swapFreePercent)
                )
                status.swapTotal.push(
                  status.bytesToSize(rawlog._source.swapTotal)
                )
                status.swapUsed.push(
                  status.bytesToSize(rawlog._source.swapUsed)
                )
                status.swapUsedPercent.push(
                  status.numberToPercentage(rawlog._source.swapUsedPercent)
                )

                status.dpisystem.push(
                  status.hostdpi,
                  status.load5,
                  status.diskFree,
                  status.diskFreePercent,
                  status.diskTotal,
                  status.diskUsed,
                  status.diskUsedPercent,
                  status.memFree,
                  status.memFreePercent,
                  status.memTotal,
                  status.memUsed,
                  status.memUsedPercent,
                  status.swapFree,
                  status.swapFreePercent,
                  status.swapTotal,
                  status.swapUsed,
                  status.swapUsedPercent
                )
              }
              // // if (x == 0) {
              //   status.dpioffline()
              // // }
            }
            // console.log(status.hostdpi)

            status.onofffunction()
            for (let y = 0; y < 1; y++) {
              if (status.runOnlyOnce == false) {
                //status.dpioffline()
              }
            }
            status.runOnlyOnce = true
            status.testtestlol()
            // status.testtestlol()
          }
          // status.testtestlol()
        })
      }
    },
    async getResourcesDPIadmin() {
      for (let x = 0; x < this.hostnameassets.length; x++) {
        let status = this
        await axios({
          method: 'POST',
          url: 'https://portal.ilog.ai:8001/api/query/search',
          headers: { Authorization: this.token },
          data: {
            start: 'now-15m',
            end: 'now',
            instance: 'http://3.1.180.118:7000',
            index: this.hostnameassets[x].replace('.ilog.ai', ''),
            stores: [],
          },
        }).then(function(response) {
          if (response.data.length > 0) {
            //console.log(response.data[1]._source.timeStamp.substring(11, 19))

            let count = response.data.length
            let rawlog = response.data[count - 1]

            for (let x = 0; x < status.assets.length; x++) {
              if (
                rawlog._source.hostname + '.ilog.ai' ==
                status.assets[x].hostname
              ) {
                status.hostdpi.push(rawlog._source.hostname + '.ilog.ai')
                // carousel card
                status.carouselCPU.push(rawlog._source.hostname + 'CPU')
                status.carouselResources.push(
                  rawlog._source.hostname + 'Resources'
                )

                // rawlog
                status.healthlog.push(rawlog)

                // cpu load
                status.load5.push(parseFloat(rawlog._source.load5).toFixed(2))

                // disk
                status.diskFree.push(
                  status.bytesToSize(rawlog._source.diskFree)
                )
                status.diskFreePercent.push(
                  status.numberToPercentage(rawlog._source.diskFreePercent)
                )
                status.diskTotal.push(
                  status.bytesToSize(rawlog._source.diskTotal)
                )
                status.diskUsed.push(
                  status.bytesToSize(rawlog._source.diskUsed)
                )
                status.diskUsedPercent.push(
                  status.numberToPercentage(rawlog._source.diskUsedPercent)
                )

                // memory
                status.memFree.push(status.bytesToSize(rawlog._source.memFree))
                status.memFreePercent.push(
                  status.numberToPercentage(rawlog._source.memFreePercent)
                )
                status.memTotal.push(
                  status.bytesToSize(rawlog._source.memTotal)
                )
                status.memUsed.push(status.bytesToSize(rawlog._source.memUsed))
                status.memUsedPercent.push(
                  status.numberToPercentage(rawlog._source.memUsedPercent)
                )

                // swap
                status.swapFree.push(
                  status.bytesToSize(rawlog._source.swapFree)
                )
                status.swapFreePercent.push(
                  status.numberToPercentage(rawlog._source.swapFreePercent)
                )
                status.swapTotal.push(
                  status.bytesToSize(rawlog._source.swapTotal)
                )
                status.swapUsed.push(
                  status.bytesToSize(rawlog._source.swapUsed)
                )
                status.swapUsedPercent.push(
                  status.numberToPercentage(rawlog._source.swapUsedPercent)
                )

                status.dpisystem.push(
                  status.hostdpi,
                  status.load5,
                  status.diskFree,
                  status.diskFreePercent,
                  status.diskTotal,
                  status.diskUsed,
                  status.diskUsedPercent,
                  status.memFree,
                  status.memFreePercent,
                  status.memTotal,
                  status.memUsed,
                  status.memUsedPercent,
                  status.swapFree,
                  status.swapFreePercent,
                  status.swapTotal,
                  status.swapUsed,
                  status.swapUsedPercent
                )
              }
              // // if (x == 0) {
              //   status.dpioffline()
              // // }
            }
            // console.log(status.hostdpi)

            status.onofffunction()
            for (let y = 0; y < 1; y++) {
              if (status.runOnlyOnce == false) {
                //status.dpioffline()
              }
            }
            status.runOnlyOnce = true
            status.testtestlol()
            // status.testtestlol()
            status.cpuloadchart = []
            status.diskchart = []
            status.memchart = []
            status.swapchart = []
            status.resourceschartall = []

            for (let x = 0; x < response.data.length; x++) {
              //console.log(response.data[x]._source.timeStamp + ' number '+  x + response.data[x]._index)
              status.cpuloadchart.push([
                response.data[x]._source.timeStamp.substring(11, 19),
                parseFloat(response.data[x]._source.load5).toFixed(2),
              ])
              status.diskchart.push([
                response.data[x]._source.timeStamp.substring(11, 19),
                parseFloat(response.data[x]._source.diskUsedPercent).toFixed(
                  2
                ) * 100,
              ])
              status.memchart.push([
                response.data[x]._source.timeStamp.substring(11, 19),
                parseFloat(response.data[x]._source.memUsedPercent).toFixed(2) *
                  100,
              ])
              status.swapchart.push([
                response.data[x]._source.timeStamp.substring(11, 19),
                parseFloat(response.data[x]._source.swapUsedPercent).toFixed(
                  2
                ) * 100,
              ])
              status.resourceschartall.push([
                response.data[x]._source.timeStamp.substring(11, 19),
                parseFloat(response.data[x]._source.diskUsedPercent).toFixed(
                  2
                ) * 100,
                parseFloat(response.data[x]._source.memUsedPercent).toFixed(2) *
                  100,
                parseFloat(
                  response.data[x]._source.swapUsedPercent * 100
                ).toFixed(2),
              ])
              status.cpuloadchart.sort()
              status.diskchart.sort()
              status.memchart.sort()
              status.swapchart.sort()
              status.resourceschartall.sort()
            }

            // for (let x = 0; x < response.data.length; x++) {
            //   //console.log(response.data[x]._source.timeStamp + ' number '+  x + response.data[x]._index)
            //   status.diskchart.push([
            //     response.data[x]._source.timeStamp.substring(11, 19),
            //     parseFloat(response.data[x]._source.diskUsedPercent).toFixed(2),
            //   ])
            //   status.diskchart.sort()
            // }
            // for (let x = 0; x < response.data.length; x++) {
            //   //console.log(response.data[x]._source.timeStamp + ' number '+  x + response.data[x]._index)
            //   status.memchart.push([
            //     response.data[x]._source.timeStamp.substring(11, 19),
            //     parseFloat(response.data[x]._source.memUsedPercent).toFixed(2),
            //   ])
            //   status.memchart.sort()
            // }
            // for (let x = 0; x < response.data.length; x++) {
            //   //console.log(response.data[x]._source.timeStamp + ' number '+  x + response.data[x]._index)
            //   status.swapchart.push([
            //     response.data[x]._source.timeStamp.substring(11, 19),
            //     parseFloat(response.data[x]._source.swapUsedPercent).toFixed(2),
            //   ])
            //   status.swapchart.sort()
            // }

            // for (let num = 0; num < response.data.length; num++) {
            //   status.cpuloadchart.push([
            //     response.data[num]._source.timeStamp.substring(11, 19),
            //     parseFloat(response.data[num]._source.load5).toFixed(2),
            //   ])

            //   status.cpuloadchart.sort()
            // }
            // console.log(status.cpuloadchart)
            //status.cpuloadchart.pop()
          } else {
            status.hostnameassetsOFF =
              status.hostnameassets.length - status.hostnameassetsON
          }
        })
      }
    },

    onofffunction() {
      if (this.load5 != 1) {
        this.hostnameassetsON += 1
        this.hostnameassetsOFF =
          this.hostnameassets.length - this.hostnameassetsON
      }
      //console.log(this.hostdpi)
    },
    // dpioffline() {
    //   console.log(this.hostnameassets)
    //   console.log(this.hostdpi)
    //   for (let x = 0; x < this.hostdpi.length; x++) {
    //     for (let y = 0; y < this.hostnameassets.length; y++) {
    //       if (x == 0) {
    //         // if (this.hostdpi[x] ==  this.hostnameassets[y]) {
    //         this.hostdpiOffData.push(this.hostnameassets[y])
    //         //this.hostdpiOffData.push(this.hostdpi)
    //         // }
    //        // console.log(this.hostdpiOffData)
    //       }
    //     }
    //   }
    //  // console.log(this.hostnameassets)
    // },
    testtestlol() {
      let a = this.hostdpi
      let b = this.hostnameassets
      var unionArr = a.concat(b)
      //console.log(unionArr);
      let c = unionArr.filter((a, b) => unionArr.indexOf(a) === b)
      let d = unionArr.filter((a, b) => unionArr.indexOf(a) !== b)
      this.hostdpiOffData = c.filter((val) => !d.includes(val))
      //console.log(this.hostdpiOffData)
    },
    bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes == 0) return '0 Bytes'
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)))
      if (i == 0) return bytes + ' ' + sizes[i]
      return (bytes / Math.pow(1000, i)).toFixed(2) + ' ' + sizes[i]
    },
    numberToPercentage(number) {
      return Math.abs(number * 100).toFixed(1) + '%'
    },
    unique() {
      let hostnameAsset = ''
      for (var x = 0; x < this.assets.length; x++) {
        if (this.updateAsset == false) {
          hostnameAsset = this.hostname + '.ilog.ai'
        } else {
          hostnameAsset = this.hostname
        }
        if (this.assets[x].hostname == hostnameAsset) {
          this.assetfailed = true
          this.notUnique = true
          return
        }
      }
      this.notUnique = false
    },
    addAsset() {
      this.submitted = true

      //stop here if form is invalid

      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.unique()
      if (this.notUnique == false) {
        this.storeAsset()
      }
    },
    storeAsset() {
      assetsRef.push({
        customerName: this.customerName,
        hostname: this.hostname + '.ilog.ai',
      })
      this.checkform = true
      this.cancelUser()
    },
    delAsset(assets) {
      this.editName = assets
      this.hostname = assets.hostname
    },
    deleteAsset() {
      assetsRef.child(this.editName.id).remove()
    },
    editUser(assets) {
      this.editName = assets
      this.hostname = assets.hostname
      this.customerName = assets.customerName
      this.updateAsset = true
    },
    cancelUser() {
      this.editName = null
      this.updateAsset = false
      this.checkEditform = false
      this.assetfailed = false
    },
    updateUser() {
      this.submitted = true

      //stop here if form is invalid
      this.$v.$touch()
      if (this.$v.hostname.$invalid) {
        return
      }

      this.unique()
      if (this.notUnique == false) {
        assetsRef.child(this.editName.id).update({
          hostname: this.hostname,
        })
        this.hostname = ''
        this.customerName = ''
        this.cancelUser()
      }
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          // Sign-out successful.
        })
      sessionStorage.removeItem('user-token')
      this.$router.push({
        name: 'login',
      })
    },
  },
}
</script>

<style>
.fontcpu {
  color: white;
}

.divider {
  width: 5px;
  height: auto;
  display: inline-block;
}

.gaugeCharts {
  position: relative;
}
</style>
